module.exports = {
	"version": 2,
	"waiters": {
		"TableExists": {
			"delay": 20,
			"operation": "DescribeTable",
			"maxAttempts": 25,
			"acceptors": [
				{
					"expected": "ACTIVE",
					"matcher": "path",
					"state": "success",
					"argument": "Table.TableStatus"
				},
				{
					"expected": "ResourceNotFoundException",
					"matcher": "error",
					"state": "retry"
				}
			]
		},
		"TableNotExists": {
			"delay": 20,
			"operation": "DescribeTable",
			"maxAttempts": 25,
			"acceptors": [
				{
					"expected": "ResourceNotFoundException",
					"matcher": "error",
					"state": "success"
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/dynamodb-2012-08-10.waiters2.json
// module id = 1970
// module chunks = 0